export const normalizeTerm = (value) => String(value || "").trim();

export const getDongFromAddress = (place) => {
  const direct = place?.state || place?.dong || place?.city;
  if (direct) return direct;

  const address = String(place?.address || place?.old_address || "").trim();
  if (!address) return "";

  // 동 이름은 주소 앞쪽(시·도 → 시·군·구 → 동)에 온다. 뒤쪽에 나오는 "상가3동",
  // "퍼플A동" 은 건물 이름이라 동네로 읽히면 안 된다. 그리고 "성동구" 의 앞
  // 두 글자처럼 뒤에 한글이 이어지는 토막도 동 이름이 아니다.
  const head = address.split(/\s+/).slice(0, 3);
  const dong = head
    .map((token) => token.match(/^[가-힣A-Za-z0-9-]+동(?![가-힣])/)?.[0])
    .find(Boolean);

  return dong || "";
};

// 주소에서 지역을 뽑는다. '동'이 없는 주소(대전 중구 …)는 통째로 비어 보여서
// 시·도 + 구/군 으로 되돌아간다.
export const getRegionFromAddress = (place) => {
  const dong = getDongFromAddress(place);
  if (dong) return dong;

  const address = String(place?.address || place?.old_address || "").trim();
  if (!address) return "";

  const [city, district] = address.split(/\s+/);
  if (city && district && /[시군구]$/.test(district)) return `${city} ${district}`;
  return city || "";
};

export const getDistanceMeters = (from, place) => {
  const lat1 = Number(from?.lat);
  const lng1 = Number(from?.lng);
  const lat2 = Number(place?.latitude);
  const lng2 = Number(place?.longitude);
  if (![lat1, lng1, lat2, lng2].every(Number.isFinite)) return null;

  const toRad = (value) => (value * Math.PI) / 180;
  const earthRadius = 6371000;
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) *
      Math.cos(toRad(lat2)) *
      Math.sin(dLng / 2) *
      Math.sin(dLng / 2);
  return Math.round(earthRadius * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
};

export const formatDistance = (meters) => {
  // 거리를 모를 때(위치 권한 없음)까지 0m 로 계산돼 모든 장소가 "1m" 로 보였다.
  if (meters === null || meters === undefined || meters === "") return "";
  const value = Number(meters);
  if (!Number.isFinite(value)) return "";
  if (value < 1000) return `${Math.max(1, Math.round(value))}m`;
  return `${(value / 1000).toFixed(value < 10000 ? 1 : 0)}km`;
};
